import _ from 'lodash';
import ProfileStore from '../stores/ProfileStore';
import mapping from 'arbitrip-common/theme/mapping';
import { COMPANY_NAME } from 'arbitrip-common/theme/constants';

/**
 * Core logic to check if company is Elal
 */
const isElalCompany = () => {
    const profile = ProfileStore.getProfile();
    const companyId = _.get(profile, 'company.id');
    return mapping[companyId] === COMPANY_NAME.ELAL;
};

/**
 * Hook to check if the current company is Elal
 * Can be used in functional components
 */
export const useElalCompany = () => {
    return isElalCompany();
};

/**
 * Function to check if the current company is Elal
 * Can be used in class components
 */
export default isElalCompany;